const styles = `:host {
  --progress-stepper-gap: var(--goto-layout-01);
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: flex;
  flex-grow: 1;
  gap: var(--progress-stepper-gap);
}
:host .steps {
  display: grid;
}
:host .steppanels {
  width: 100%;
}

:host([orientation=horizontal]) {
  flex-direction: column;
}
:host([orientation=horizontal]) .steps {
  column-gap: var(--goto-spacing-02);
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}
:host([orientation=horizontal]) ::slotted([slot=step]) {
  border-top-style: solid;
  padding: var(--goto-spacing-02) 0;
  gap: var(--goto-spacing-02);
}

:host([orientation=vertical]) {
  flex-direction: row;
}
:host([orientation=vertical]) .steps {
  row-gap: var(--goto-spacing-02);
  grid-template-rows: repeat(auto-fit, minmax(0, 1fr));
}
:host([orientation=vertical]) ::slotted([slot=step]) {
  border-left-style: solid;
  padding: 0 0 0 var(--goto-spacing-02);
  gap: var(--goto-spacing-03);
  min-height: var(--goto-layout-06);
  width: 256px;
}`; export default styles;